import { render, staticRenderFns } from "./CompareBuilds.vue?vue&type=template&id=c6ae6250"
import script from "./CompareBuilds.vue?vue&type=script&lang=js"
export * from "./CompareBuilds.vue?vue&type=script&lang=js"
import style0 from "./CompareBuilds.vue?vue&type=style&index=0&id=c6ae6250&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports